import { render, staticRenderFns } from "./business_integral_order_detail.vue?vue&type=template&id=7ef61e4d&scoped=true"
import script from "./business_integral_order_detail.vue?vue&type=script&lang=ts"
export * from "./business_integral_order_detail.vue?vue&type=script&lang=ts"
import style0 from "./business_integral_order_detail.vue?vue&type=style&index=0&id=7ef61e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef61e4d",
  null
  
)

export default component.exports